import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { Select, MenuItem, IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axiosInstance from "../../Axios/axiosInstance";
import { useNavigate } from "react-router-dom";
import Dashboard from "./../../Components/Dashboard/Dashboard.css";
import styled from "@emotion/styled";

const LeadTable = () => {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [editedLead, setEditedLead] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [deleteConfirmationDialog, setDeleteConfirmationDialog] =
    useState(false);
  const [deleteLeadId, setDeleteLeadId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("api/getLeads");
        if (response && response.data) {
          setLeads(response.data);
        }
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    };

    fetchData();
  }, [leads]);

  const handleStatusChange = async (event, leadId) => {
    try {
      const updatedLeads = leads.map((lead) =>
        lead.id === leadId ? { ...lead, leadstatus: event.target.value } : lead
      );
      setLeads(updatedLeads);

      const response = await axiosInstance.put(
        `/api/updateLeadStatus/${leadId}`,
        {
          leadstatus: event.target.value,
        }
      );

      if (response && response.status === 200) {
        setOpenSnackbar(true);
        setSubmitMessage("Lead status updated successfully!");
      } else {
        console.error("Failed to update lead status");
      }
    } catch (error) {
      console.error("Error updating lead status:", error);
    }
  };

  const handleEdit = (lead) => {
    navigate(`/dashboard/updateLead/${lead.id}`);
  };

  const handleConfirmDelete = async (leadId) => {
    try {
      const response = await axiosInstance.delete(`/api/deleteLead/${leadId}`);

      if (response && response.status === 200) {
        setLeads((prevLeads) => prevLeads.filter((lead) => lead.id !== leadId));
        setOpenSnackbar(true);
        setSubmitMessage("Lead deleted successfully!");
        setTimeout(() => {
          setOpenSnackbar(false);
          setSubmitMessage("");
        }, 3000);
      } else {
        console.error("Failed to delete lead");
      }
    } catch (error) {
      console.error("Error deleting lead:", error);
    }

    setDeleteConfirmationDialog(false);
  };

  const columns = [
    "Lead Name",
    "Contact No",
    "Email",
    "Location",
    "Source",
    "Comments",
    "State",
    {
      name: "Lead State",
      options: {
        customBodyRender: (value, tableMeta) => (
          <Select
            value={leads[tableMeta.rowIndex].changeStatus || ""}
            onChange={(e) =>
              handleStatusChange(e, leads[tableMeta.rowIndex].id)
            }
          >
            <MenuItem value="pitched">Pitched</MenuItem>
            <MenuItem value="negotiation">Negotiation</MenuItem>
            <MenuItem value="demo">Demo</MenuItem>
            <MenuItem value="closedlost">Closed Lost</MenuItem>
            <MenuItem value="closedwon">Closed Won</MenuItem>
            <MenuItem value="rnr">RNR</MenuItem>
            <MenuItem value="junk">Junk</MenuItem>
          </Select>
        ),
      },
    },

    "Status",
    {
      name: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => (
          <>
            <IconButton onClick={() => handleEdit(leads[tableMeta.rowIndex])}>
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => handleConfirmDelete(leads[tableMeta.rowIndex].id)}
            >
              <Delete />
            </IconButton>
          </>
        ),
      },
    },
  ];

  const data = leads.map((lead) => [
    lead.leadname,
    lead.contactno,
    lead.leademail,
    lead.leadlocation,
    lead.leadsource,
    lead.leadcomments,
    lead.leadstate,
    lead.changestatus,
    lead.status, // Change this to the appropriate field for Lead status
    lead.id, // Assuming id is the unique identifier for each lead
  ]);

  const options = {
    filter: true,
    selectableRows: "none",
  };

  return (
    <MUIDataTable
      title={"Leads Data"}
      style={{ fontSize: "16px" }}
      data={data}
      columns={columns}
      options={options}
    />
  );
};

export default LeadTable;
